import React from 'react';
import { Card } from 'react-bootstrap';
import './bloodwork-anemia-status.css';
import { LabsmartsGuage } from '../charts/LabsmartsGauge';
import { BloodworkAnalysis } from '../../models/BloodworkAnalysis';
import { HYDRATION_PANEL_OWNS_DEHYDRATION_TEXT } from './dehydration-insights';

type Props = {
  bloodworkAnalysis: BloodworkAnalysis;
};

export class AnemiaStatus extends React.Component<Props, {}> {
  
  possibleRootCauses = (bloodworkAnalysis: BloodworkAnalysis) => {
    const possibleRootCauses = bloodworkAnalysis.possibleRootCauses();
    if (possibleRootCauses.length) {
      return (
        <div className="possible-root-causes-container">
          <div className="possible-root-causes-title">Possible Root Causes</div>
          <ul className="possible-root-causes">
          {
            bloodworkAnalysis.possibleRootCauses().map((cause, index) => {
              return <li className="possible-root-cause" key={index}>{cause}</li>;
            })
          }
          </ul>
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    const { bloodworkAnalysis } = this.props;
    if (!bloodworkAnalysis.bloodwork) {
      return null;
    }

    console.log(bloodworkAnalysis.redBloodCellSize);
    console.log(bloodworkAnalysis.redBloodCellColor);

    return (
        <Card className="evaluationPanel" id="rbc-evaluation">
            <Card.Header className="evaluationPanelHeading">
              RBC Insights
            </Card.Header>
            <Card.Body>
              <div className="anemiaStatusContainer">
                <LabsmartsGuage
                  text="Suboptimal Blood Oxygen Delivery is"
                  chartContainerId="anemiaStatusGuage"
                  bloodwork={bloodworkAnalysis.bloodwork}
                  category={bloodworkAnalysis.anemicProbabilityCategory}
                  probability={bloodworkAnalysis.anemicProbability}
                  ticks={[0, 50, 70, 90]}
                />
                <div className="colorSize">
                  <div className="rbcSizeColor rbcSize">
                    <div className="statusTitle">RBC Size</div>
                    <div className="statusType">{bloodworkAnalysis.redBloodCellSize.type}</div>
                    <div className="statusName">({bloodworkAnalysis.redBloodCellSize.name})</div>
                  </div>
                  <div className="rbcSizeColor rbcColor">
                    <div className="statusTitle">RBC Color</div>
                    <div className="statusType">{bloodworkAnalysis.redBloodCellColor.type}</div>
                    <div className="statusName">({bloodworkAnalysis.redBloodCellColor.name})</div>
                  </div>
                  <div className="clearfix" /> 
                </div>
                {
                  bloodworkAnalysis.nutrientDeficiencyOrInflammationLikelyText ? 
                    <div className="nutrient-deficiency-or-inflammation-likely">
                      {bloodworkAnalysis.nutrientDeficiencyOrInflammationLikelyText}
                    </div> 
                  : null
                }
                {
                  bloodworkAnalysis.boneMarrowAnalysis.boneMarrowOverproductionIsLikely ?
                    <div className="condition-section">
                      Bone Marrow Overproduction is Likely
                    </div>
                  : null
                }
                {this.possibleRootCauses(bloodworkAnalysis)}
                {
                  // Dehydration is MOVING to the Electrolytes hydration panel,
                  // and stays here until that panel actually deploys — it is on
                  // hold, so the handover flag is still false everywhere and
                  // this label is what every report has. Keyed off the handover
                  // rather than off "does the panel render", so a build that
                  // shows the panel to a developer cannot take the label out of
                  // the report they are checking.
                  !HYDRATION_PANEL_OWNS_DEHYDRATION_TEXT &&
                  bloodworkAnalysis.isAnyDehydrationPossibleOrHigher() ?
                    <div className="condition-section">
                      {bloodworkAnalysis.deriveDehydrationText()}
                    </div>
                  : null
                }
                {
                  bloodworkAnalysis.isPoorOxygenationPossibleOrHigher() ?
                    <div className="condition-section">
                      {bloodworkAnalysis.derivePoorOxygenationText()}
                    </div>
                  : null
                }
                {
                  bloodworkAnalysis.isPoorOxygenationDueToSmoking() ?
                    <div className="condition-section">
                      {bloodworkAnalysis.derivePoorOxygenationTextForSmoker()}
                    </div>
                  : null
                }
              </div>
            </Card.Body>
        </Card>
    );
  }
}
